import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from '@shared-features/buttons/button/button.component';

@Component({
    selector: 'button-cancel',
    imports: [ButtonComponent],
    templateUrl: './button-cancel.component.html',
    styleUrl: './button-cancel.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonCancelComponent {
    id = input.required<string>();
    disabled = input<boolean>(false);

    label = input<string>('cancel');
    text = input<boolean>(false);

    onClick = output<MouseEvent>();
}
